




import { Vue, Component, Prop } from "vue-property-decorator";

import { isOtherAllowedInput, isNumberInput } from "@share/common/controls/utils/charcodeCheckers"

@Component({})

export default class TimeSelector extends Vue {
  @Prop({ default: "" }) value: string;
  @Prop({ default: "00:00" }) placeholder: string;

  normilizeNumPad(charCode: number) {
    if(charCode > 57) {
      charCode-= 48;
    }

    return charCode
  }

  keydown(e: KeyboardEvent) {
    let charCode = (e.which) ? e.which : e.keyCode;

    //dot or comma
    if(charCode === 110 || charCode === 190) {
      e.preventDefault();
      return
    }

    if(isOtherAllowedInput(charCode, e)) {
      return
    }
    const isNumber = isNumberInput(charCode);

    if(isNumber) {
      charCode = this.normilizeNumPad(charCode)
    }

    const numberRestricted = (
      isNumber &&
      (
        this.value.length > 4 ||
        this.value.length === 0 && charCode > 50 ||
        this.value.length === 2 && charCode > 53 ||
        this.value.length === 3 && charCode > 53 ||
        (this.value.length === 1 && parseInt(this.value) >= 2 && charCode > 51)
      )
    )

    if(numberRestricted || !isNumber){
      e.preventDefault();
    }
  }

  input(e: any) {

    const value = e.target.value;
    let newValue = ""

    if(value.length === 3 && value.slice(value.length - 1) !== ":") {
      newValue = value.slice(0, -1) + ':' + value.slice(value.length - 1)
    }
    else {
      newValue = value
    }

    this.$emit('input', newValue)
  }

}
